<div nz-row nzJustify="space-between">
	<div nz-col>
		<button
			nz-button
			nzType="default"
			(click)="addType()"
			i18n="@@ref.main.tab.tails.buttonNew">
			New
		</button>
		<button
			nz-button
			nz-dropdown
			[nzDropdownMenu]="menu"
			i18n="@@ref.main.tab.tails.buttonExport">
			Export
			<span nz-icon nzType="down"></span>
		</button>
		<nz-dropdown-menu #menu="nzDropdownMenu">
			<ul nz-menu>
				<li nz-menu-item (click)="downloadCsvFile()">CSV</li>
				<li nz-menu-item (click)="downloadXmlFile()">XML</li>
			</ul>
		</nz-dropdown-menu>
	</div>

	<div nz-col nz-row>
		<div nz-col>
			<nz-input-group
				[nzAddOnBefore]="searchValueBeforeTemplate"
				[nzSuffix]="iataClearTpl">
				<input
					type="text"
					nz-input
					[(ngModel)]="settingValue.searchIata"
					placeholder="IATA" />
			</nz-input-group>
			<ng-template #searchValueBeforeTemplate>
				<span i18n="@@ref.main.tab.tails.fieldSearch">Search</span>
			</ng-template>
			<ng-template #iataClearTpl>
				<span
					nz-icon
					class="ant-input-clear-icon"
					nzTheme="fill"
					nzType="close-circle"
					*ngIf="settingValue.searchIata"
					(click)="settingValue.searchIata = ''"></span>
			</ng-template>
		</div>
		<div nz-col>
			<nz-input-group [nzSuffix]="icaoClearTpl">
				<input
					type="text"
					nz-input
					[(ngModel)]="settingValue.searchIcao"
					placeholder="ICAO" />
			</nz-input-group>
			<ng-template #icaoClearTpl>
				<span
					nz-icon
					class="ant-input-clear-icon"
					nzTheme="fill"
					nzType="close-circle"
					*ngIf="settingValue.searchIcao"
					(click)="settingValue.searchIcao = ''"></span>
			</ng-template>
		</div>
		<div nz-col>
			<nz-input-group [nzSuffix]="nameClearTpl">
				<input
					type="text"
					nz-input
					[(ngModel)]="settingValue.searchName"
					placeholder="Name"
					i18n-placeholder="@@ref.main.tab.tails.fieldSearchName" />
			</nz-input-group>
			<ng-template #nameClearTpl>
				<span
					nz-icon
					class="ant-input-clear-icon"
					nzTheme="fill"
					nzType="close-circle"
					*ngIf="settingValue.searchName"
					(click)="settingValue.searchName = ''"></span>
			</ng-template>
		</div>
	</div>
</div>

<nz-table
	#sortTable
	[nzData]="listOfDisplayAirlines"
	nzTableLayout="fixed"
	[nzLoading]="settingValue.loadingList"
	nzSize="small"
	nzPaginationType="small"
	nzShowSizeChanger
	nzPageSize="15"
	[nzPageIndex]="settingValue.pageIndex"
	(nzPageIndexChange)="onPageIndexChanged($event)"
	[nzPageSizeOptions]="[15, 30, 50]">
	<thead>
		<tr>
			<th
				*ngFor="let column of listOfColumn"
				[nzSortFn]="column.compare"
				[nzSortPriority]="column.priority">
				{{ column.title }}
			</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of sortTable.data" (click)="openAirline(item.id)">
			<td>{{ item.iata }}</td>
			<td>{{ item.icao }}</td>
			<td>{{ item.codeLocal }}</td>
			<td>{{ item.nameLocal }}</td>
			<td>{{ item.lastupdate | date : 'dd.MM.yyy HH:mm' }}</td>
		</tr>
	</tbody>
</nz-table>

<nz-modal
	[(nzVisible)]="settingValue.isVisibleModal"
	[nzTitle]="modalTitle"
	[nzContent]="modalContent"
	[nzFooter]="modalFooter"
	(nzOnCancel)="closeModal()"
	nzWidth="1000px">
	<nz-spin [nzSpinning]="settingValue.loadingModal">
		<ng-template #modalTitle>
			<span *ngIf="!airline.id">
				<span i18n="@@ref.main.modal.airline.headerAppend">Airline append</span>
				&nbsp;{{ airline.nameLocal }}
			</span>
			<span *ngIf="airline.id">
				<span i18n="@@ref.main.modal.airline.headerEdit">Edit airline</span>
				&nbsp;{{ airline.nameLocal }}
			</span>
		</ng-template>

		<ng-template #modalContent>
			<form nz-form [formGroup]="airlineForm" nzLayout="vertical">
				<div nz-row [nzGutter]="16">
					<div nz-col nzSpan="24" *ngIf="airlineForm.errors?.allEmpty">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.err.iataIcaoLocalCodeReq">
									IATA or ICAO or Local code is required
								</span>
							</nz-form-label>
						</nz-form-item>
					</div>
					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.field.iataCode">
									IATA code
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback [nzErrorTip]="iataErrorTpl">
								<input nz-input formControlName="iata" />
								<ng-template #iataErrorTpl let-control>
									<ng-container *ngIf="control.hasError('required')">
										<span
											i18n="@@ref.main.modal.airline.err.iataIcaoLocalCodeReq">
											IATA or ICAO or Local code is required
										</span>
									</ng-container>
									<ng-container *ngIf="airlineForm.hasError('reqLength')">
										<span i18n="@@ref.main.modal.airline.err.iataCodeMinLength">
											IATA code minimum length is
										</span>
										{{
											airlineForm.controls['iata'].errors.reqLength.reqLength
										}}
									</ng-container>
									<ng-container
										*ngIf="control.hasError('onlyEnglishAndNumbers')">
										<span i18n="@@ref.main.modal.airline.err.iataCodeEnOnly">
											IATA code is English only
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.field.icaoCode">
									ICAO code
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback [nzErrorTip]="icaoErrorTpl">
								<input nz-input formControlName="icao" />
								<ng-template #icaoErrorTpl let-control>
									<ng-container *ngIf="airlineForm.hasError('required')">
										<span
											i18n="@@ref.main.modal.airline.err.iataIcaoLocalCodeReq">
											IATA or ICAO or Local code is required
										</span>
									</ng-container>
									<ng-container *ngIf="control.hasError('reqLength')">
										<span i18n="@@ref.main.modal.airline.err.icaoCodeMinLength">
											ICAO code minimum length is
										</span>
										{{
											airlineForm.controls['icao'].errors.reqLength.reqLength
										}}
									</ng-container>
									<ng-container
										*ngIf="control.hasError('onlyEnglishAndNumbers')">
										<span i18n="@@ref.main.modal.airline.err.icaoCodeEnOnly">
											ICAO code is English only
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label>
								<span i18n="@@ref.main.modal.airline.field.englishCode">
									English code
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback [nzErrorTip]="codeEnErrorTpl">
								<input nz-input formControlName="codeEn" />
								<ng-template #codeEnErrorTpl let-control>
									<ng-container *ngIf="control.hasError('onlyEnglish')">
										<span i18n="@@ref.main.modal.airline.err.englishCodeEnOnly">
											Code is English only
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.field.localCode">
									Local code
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback [nzErrorTip]="codeRuErrorTpl">
								<input nz-input formControlName="codeRu" />
								<ng-template #codeRuErrorTpl let-control>
									<ng-container *ngIf="airlineForm.hasError('required')">
										<span
											i18n="@@ref.main.modal.airline.err.iataIcaoLocalCodeReq">
											IATA or ICAO or Local code is required
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.field.englishName">
									English name
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback [nzErrorTip]="nameEnErrorTpl">
								<input nz-input formControlName="nameEn" />
								<ng-template #nameEnErrorTpl let-control>
									<ng-container *ngIf="control.hasError('required')">
										<span i18n="@@ref.main.modal.airline.err.englishNameReq">
											English name is required
										</span>
									</ng-container>
									<ng-container *ngIf="control.hasError('onlyEnglish')">
										<span i18n="@@ref.main.modal.airline.err.englishNameEnOnly">
											Name is English only
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.field.localName">
									Local name
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback [nzErrorTip]="nameRuErrorTpl">
								<input nz-input formControlName="nameRu" />
								<ng-template #nameRuErrorTpl let-control>
									<ng-container *ngIf="control.hasError('required')">
										<span i18n="@@ref.main.modal.airline.err.localNameReq">
											Local name is required
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="24">
						<p i18n="@@ref.main.modal.airline.field.weight">Weight</p>
					</div>

					<div nz-col nzSpan="4">
						<nz-form-item>
							<nz-form-label>
								<span i18n="@@ref.main.modal.airline.field.adultWinter">
									Adult winter
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback>
								<input
									nz-input
									type="number"
									formControlName="winterWeightAdult" />
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="4">
						<nz-form-item>
							<nz-form-label>
								<span i18n="@@ref.main.modal.airline.field.adultSummer">
									Adult summer
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback>
								<input
									nz-input
									type="number"
									formControlName="summerWeightAdult" />
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="4">
						<nz-form-item>
							<nz-form-label>
								<span i18n="@@ref.main.modal.airline.field.childWinter">
									Child winter
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback>
								<input
									nz-input
									type="number"
									formControlName="winterWeightChild" />
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="4">
						<nz-form-item>
							<nz-form-label>
								<span i18n="@@ref.main.modal.airline.field.childSummer">
									Child summer
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback>
								<input
									nz-input
									type="number"
									formControlName="summerWeightChild" />
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="4">
						<nz-form-item>
							<nz-form-label>
								<span i18n="@@ref.main.modal.airline.field.infantWinter">
									Infant winter
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback>
								<input
									nz-input
									type="number"
									formControlName="winterWeightInfant" />
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="4">
						<nz-form-item>
							<nz-form-label>
								<span i18n="@@ref.main.modal.airline.field.infantSummer">
									Infant summer
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback>
								<input
									nz-input
									type="number"
									formControlName="summerWeightInfant" />
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.field.country">
									Country
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback [nzErrorTip]="countryErrorTpl">
								<nz-select
									[nzOptions]="listOfDisplayCountries"
									formControlName="countryId">
								</nz-select>
								<ng-template #countryErrorTpl let-control>
									<ng-container *ngIf="control.hasError('required')">
										<span i18n="@@ref.main.modal.airline.err.countryReq">
											Country is required
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label>
								<span i18n="@@ref.main.modal.airline.field.international">
									International
								</span>
							</nz-form-label>
							<nz-form-control nzHasFeedback>
								<nz-switch formControlName="international"></nz-switch>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.field.dtRangeStart">
									Date range start
								</span>
							</nz-form-label>
							<nz-form-control [nzErrorTip]="dtRangeStartErrorTpl">
								<nz-date-picker
									formControlName="dtRangeStart"
									nzFormat="dd.MM.yyyy"
									nzUtcOffset="00:00"></nz-date-picker>
								<ng-template #dtRangeStartErrorTpl let-control>
									<ng-container *ngIf="control.hasError('required')">
										<span i18n="@@ref.main.modal.airline.err.dtRangeStartReq">
											Date range start is required
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>

					<div nz-col nzSpan="12">
						<nz-form-item>
							<nz-form-label nzRequired>
								<span i18n="@@ref.main.modal.airline.field.dtRangeFinish">
									Date range finish
								</span>
							</nz-form-label>
							<nz-form-control [nzErrorTip]="dtRangeFinishErrorTpl">
								<nz-date-picker
									formControlName="dtRangeFinish"
									[nzFormat]="'dd.MM.yyyy'"
									nzUtcOffset="00:00"></nz-date-picker>
								<ng-template #dtRangeFinishErrorTpl let-control>
									<ng-container *ngIf="control.hasError('required')">
										<span i18n="@@ref.main.modal.airline.err.dtRangeFinishReq">
											Date range finish is required
										</span>
									</ng-container>
								</ng-template>
							</nz-form-control>
						</nz-form-item>
					</div>
				</div>
			</form>
		</ng-template>

		<ng-template #modalFooter>
			<div nz-row nzJustify="space-between">
				<div nz-col>
					<button
						*ngIf="airline.id"
						nz-button
						nzType="default"
						(click)="duplicate()"
						i18n="@@ref.main.modal.tail.button.duplicate">
						Duplicate
					</button>
					<button
						*ngIf="airline.id"
						nz-button
						nzType="primary"
						nzDanger
						(click)="showDeleteConfirm()">
						Delete
					</button>
				</div>

				<div nz-col>
					<button
						*ngIf="airline.id"
						nz-button
						nzType="primary"
						(click)="save()"
						[nzLoading]="settingValue.saving"
						i18n="@@ref.main.modal.tail.button.save"
						[disabled]="!airlineForm.valid">
						Save
					</button>
					<button
						*ngIf="!airline.id"
						nz-button
						nzType="primary"
						(click)="add()"
						[nzLoading]="settingValue.saving"
						i18n="@@ref.main.modal.tail.button.append"
						[disabled]="!airlineForm.valid">
						Append
					</button>
					<button
						nz-button
						nzType="default"
						(click)="closeModal()"
						i18n="@@ref.main.modal.tail.button.close">
						Close
					</button>
				</div>
			</div>
		</ng-template>
	</nz-spin>
</nz-modal>
